export default "__VITE_ASSET__oUqVZpWQ__"